import { h, defineComponent } from 'vue';
import { RouteName } from '@/ui/routes';
import { Button } from '../Button';

export interface RedirectButtonProps {
  routeName: RouteName;
  text: string;
  icon?: string;
  routeParams?: Record<string, string>;
  routeQuery?: Record<string, string>;
}

export const RedirectButton = defineComponent<RedirectButtonProps>({
  name: 'RedirectButton',
  props: ['routeName', 'text', 'icon', 'routeParams', 'routeQuery'],
  setup(props) {
    return function render() {
      return h(Button, {
        attrs: {
          tag: 'router-link',
          to: {
            name: props.routeName,
            params: props.routeParams,
            query: props.routeQuery,
          },
          ...(props.icon !== undefined ? { iconLeft: props.icon } : {}),
        },
      }, props.text);
    };
  },
});
